import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { SelectItems } from "./select-item";
import { type OptionType } from "@/types/form";

export type SelectOptions = OptionType[];
interface SelectInputProps {
  options: SelectOptions;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  defaultValue?: string;
  fullWidth?: boolean;
  className?: string;
}

export const SelectInput = ({
  options,
  placeholder = "Select an option",
  value,
  onChange,
  disabled,
  fullWidth,
  defaultValue,
  className,
}: SelectInputProps) => {
  return (
    <Select defaultValue={defaultValue} value={value} onValueChange={onChange}>
      <SelectTrigger
        disabled={disabled}
        className={cn(fullWidth && "w-full", className)}
      >
        <SelectValue placeholder={placeholder} numberOfLines={1}>
          {options.find((option) => option.value === value)?.label}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItems options={options} />
      </SelectContent>
    </Select>
  );
};

SelectInput.displayName = "SelectInput";
